import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrow = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="12"
    viewBox="0 0 9 12"
    fill="none"
    {...props}
  >
    <path
      id="Polygon 1"
      d="M9 6L-4.89399e-07 11.1962L-3.51373e-08 0.803847L9 6Z"
      fill={fill ?? '#D9D9D9'}
    />
  </svg>
);

export default SvgArrow;
